export const COMPONENT_NAME = 'Search';